module.exports = __webpack_public_path__ + "img/coin_4.bfb9d988.png";